import React from "react";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { theme, size } from "../../helpers/theme";
import SessionService from "../../services/session-service";
import { url, urlArray } from "../../utils/url";
import Footer from "../footer/footer";
import Header from "../header/header";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const _path: string[] = [
    url.homePage,
    url.aboutUs,
    url.faq,
    url.offer,
    url.regulations,
    url.privacyPolicy,
    url.contact,
    url.login,
    url.offerForm,
    url.offerFormSummary,
    url.thankYouPage,
    url.offerCreate,
    url.offerInitialAcceptance,
  ];
  const location = useLocation();
  const path: string = location.pathname;
  //Dla widoku sumy w order//
  const isSummWidth: boolean = true;
  //
  const isErrorPage: boolean = urlArray.includes(path) ? false : true;
  const isNerrowPage: boolean = _path.includes(path) ? true : false;
  const logedWidth: boolean = isErrorPage ? true : isNerrowPage;

  const user = SessionService.getUser();
  const isLoged = user && user.token_dostepu !== null ? true : false;

  interface LayoutContainerProps {
    logedWidth: boolean;
    path?: string;
    isLoged?: boolean;
  }
  return (
    <>
      <LayoutContainer logedWidth={isNerrowPage} path={path} isLoged={isLoged}>
        <Header isNerrowPage={isNerrowPage} />
        <MainSection>{children}</MainSection>
        <Footer />
      </LayoutContainer>
    </>
  );
};

export default Layout;

const LayoutContainer = styled.div<{
  logedWidth: boolean;
  path: string;
  isLoged: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: ${(props: any) => (props.logedWidth ? "80%" : "100%")};
  margin: auto;

  ${(props: any) =>
    props.path === "/offer-form/summary"
      ? `
         @media (max-width:1300px){
         width: 96%;
        }
        `
      : ""}

  @media ${theme.device.Mlaptop} {
    width: 96%;
  }
`;

const MainSection = styled.div`
  @media (max-width: ${size.laptop}) {
    margin-top: 0px;
  }
`;
